import $ from 'jquery';
import logger from "../common/Logger"
import CoreService from './CoreService'
import ApiService from './ApiService'

class ActionConfigService {
    static loadActionConfig() {
        ApiService.makeRequest("/api/bots/default/action-config", {
            type: "GET",
            success: function (actionConfig) {
                $("#actionConfig").val(actionConfig);
            },
            error: function (result, err) {
                if (err) logger.error(err);
                CoreService.showPassiveError("Sorry, we can't fetch your action configuration right now.");
            }
        });
    }

    static saveActionConfig() {
        ApiService.makeRequest("/api/bots/default/action-config", {
            type: "POST",
            data: $("#actionConfig").val(),
            success: function () {
                CoreService.navigateToHome();
            },
            error: function (result, err) {
                if (err) logger.error(err)
            }
        });
    }

    static handleFileSelect() {
        const files = document.getElementById("actionConfig-file").files; // FileList object

        files.forEach((f) => {
            // Only process YAML files.
            if (!f.name.match('(.*)(.yaml|.yml)')) {
                CoreService.showPassiveError('Sorry, you can only upload files with a .yml or .yaml extension.');
                return
            }

            const reader = new FileReader();

            reader.onload = (function (theFile) {
                logger.debug(`Reading file ${theFile.name}`);
                return function (e) {
                    $("#actionConfig").val(e.target.result);
                };
            })(f);

            reader.readAsText(f);
        });
    }
}

export default ActionConfigService;



// WEBPACK FOOTER //
// ./src/modules/service/ActionConfigService.js